var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 97,
    viewBox: "0 0 952 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M887 0H-45V77H887V0Z",
    fill: "#50A3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M910 0H899V77H910V0Z",
    fill: "#50A3B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M931 0H920V77H931V0Z",
    fill: "#50A3B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M952 0H941V77H952V0Z",
    fill: "#50A3B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.51917b2f538d4eb10d39e122e41dab8f.svg";
export { ForwardRef as ReactComponent };